(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buddhamani-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-bm-menu-close]');
    if (!closeButton) return;
    const drawer = closeButton.closest('details');
    if (drawer) drawer.removeAttribute('open');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.bm-mobile-menu[open]').forEach((drawer) => drawer.removeAttribute('open'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buddhamani-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeMobileCarousels = (home) => {
      if (home.dataset.bmMobileCarouselsReady === 'true') return;

      const mobileQuery = window.matchMedia('(max-width: 560px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const cleanups = [];

      Array.from(home.querySelectorAll('[data-bm-mobile-carousel]')).forEach((carousel) => {
        const track = carousel.querySelector('[data-bm-mobile-carousel-track]');
        const previous = carousel.querySelector('[data-bm-mobile-carousel-prev]');
        const next = carousel.querySelector('[data-bm-mobile-carousel-next]');
        const dotsContainer = carousel.querySelector('.bm-mobile-carousel__dots');
        let dots = Array.from(carousel.querySelectorAll('.bm-mobile-carousel__dots i'));
        const items = Array.from(track?.children || []);
        const itemsPerView = Math.max(1, Number(carousel.dataset.bmItemsPerView || 1));
        const pageCount = Math.ceil(items.length / itemsPerView);
        const autoplayDelay = Math.max(0, Number(carousel.dataset.bmAutoplay || 0));
        if (!track || !previous || !next) return;
        if (pageCount < 2) {
          previous.closest('.bm-mobile-carousel__controls')?.setAttribute('hidden', '');
          return;
        }
        previous.closest('.bm-mobile-carousel__controls')?.removeAttribute('hidden');
        if (dotsContainer && dots.length !== pageCount) {
          dotsContainer.replaceChildren(...Array.from({ length: pageCount }, () => document.createElement('i')));
          dots = Array.from(dotsContainer.querySelectorAll('i'));
        }

        let page = 0;
        let autoplayTimer;
        let scrollTimer;
        let pointerInside = false;
        let focusInside = false;

        const updateDots = () => {
          dots.forEach((dot, index) => dot.classList.toggle('is-active', index === page));
        };

        const stopAutoplay = () => {
          window.clearInterval(autoplayTimer);
        };

        const pageOffset = (targetPage) => {
          const item = items[Math.min(items.length - 1, targetPage * itemsPerView)];
          return item ? item.offsetLeft - items[0].offsetLeft : track.clientWidth * targetPage;
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (!mobileQuery.matches || reducedMotion.matches || autoplayDelay < 1 || pointerInside || focusInside || document.hidden) return;
          autoplayTimer = window.setInterval(() => goTo(page + 1), autoplayDelay);
        };

        const goTo = (target, behavior = 'smooth') => {
          page = ((target % pageCount) + pageCount) % pageCount;
          updateDots();
          track.scrollTo({
            left: pageOffset(page),
            behavior: reducedMotion.matches ? 'auto' : behavior
          });
        };

        const restartAutoplay = () => {
          stopAutoplay();
          startAutoplay();
        };

        const handlePrevious = () => {
          goTo(page - 1);
          restartAutoplay();
        };

        const handleNext = () => {
          goTo(page + 1);
          restartAutoplay();
        };

        const handleKeydown = (event) => {
          if (!mobileQuery.matches) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          goTo(page + (event.key === 'ArrowLeft' ? -1 : 1));
          restartAutoplay();
        };

        const handleScroll = () => {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(() => {
            if (!track.clientWidth) return;
            let closestPage = 0;
            let closestDistance = Math.abs(track.scrollLeft - pageOffset(0));
            for (let index = 1; index < pageCount; index += 1) {
              const distance = Math.abs(track.scrollLeft - pageOffset(index));
              if (distance < closestDistance) {
                closestPage = index;
                closestDistance = distance;
              }
            }
            page = closestPage;
            updateDots();
          }, 120);
        };

        const handlePointerDown = () => {
          stopAutoplay();
        };

        const handlePointerUp = () => {
          restartAutoplay();
        };

        const handlePointerEnter = () => {
          pointerInside = true;
          stopAutoplay();
        };

        const handlePointerLeave = () => {
          pointerInside = false;
          startAutoplay();
        };

        const handleFocusIn = () => {
          focusInside = true;
          stopAutoplay();
        };

        const handleFocusOut = (event) => {
          if (carousel.contains(event.relatedTarget)) return;
          focusInside = false;
          startAutoplay();
        };

        const handleVisibility = () => {
          if (document.hidden) stopAutoplay();
          else startAutoplay();
        };

        const handleModeChange = () => {
          stopAutoplay();
          track.tabIndex = mobileQuery.matches ? 0 : -1;
          goTo(0, 'auto');
          startAutoplay();
        };

        previous.addEventListener('click', handlePrevious);
        next.addEventListener('click', handleNext);
        track.addEventListener('keydown', handleKeydown);
        track.addEventListener('scroll', handleScroll, { passive: true });
        track.addEventListener('pointerdown', handlePointerDown, { passive: true });
        track.addEventListener('pointerup', handlePointerUp, { passive: true });
        track.addEventListener('pointercancel', handlePointerUp, { passive: true });
        carousel.addEventListener('mouseenter', handlePointerEnter);
        carousel.addEventListener('mouseleave', handlePointerLeave);
        carousel.addEventListener('focusin', handleFocusIn);
        carousel.addEventListener('focusout', handleFocusOut);
        document.addEventListener('visibilitychange', handleVisibility);
        if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', handleModeChange);
        else mobileQuery.addListener(handleModeChange);

        const handleResize = () => goTo(page, 'auto');
        const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(handleResize) : null;
        if (resizeObserver) resizeObserver.observe(track);
        else window.addEventListener('resize', handleResize);

        track.tabIndex = mobileQuery.matches ? 0 : -1;
        updateDots();
        startAutoplay();

        cleanups.push(() => {
          stopAutoplay();
          window.clearTimeout(scrollTimer);
          resizeObserver?.disconnect();
          if (!resizeObserver) window.removeEventListener('resize', handleResize);
          previous.removeEventListener('click', handlePrevious);
          next.removeEventListener('click', handleNext);
          track.removeEventListener('keydown', handleKeydown);
          track.removeEventListener('scroll', handleScroll);
          track.removeEventListener('pointerdown', handlePointerDown);
          track.removeEventListener('pointerup', handlePointerUp);
          track.removeEventListener('pointercancel', handlePointerUp);
          carousel.removeEventListener('mouseenter', handlePointerEnter);
          carousel.removeEventListener('mouseleave', handlePointerLeave);
          carousel.removeEventListener('focusin', handleFocusIn);
          carousel.removeEventListener('focusout', handleFocusOut);
          document.removeEventListener('visibilitychange', handleVisibility);
          if (mobileQuery.removeEventListener) mobileQuery.removeEventListener('change', handleModeChange);
          else mobileQuery.removeListener(handleModeChange);
        });
      });

      home.bmMobileCarouselsCleanup = () => cleanups.forEach((cleanup) => cleanup());
      home.dataset.bmMobileCarouselsReady = 'true';
    };

    const initialize = (scope = document) => {
      const homes = scope.matches?.('.bm-home')
        ? [scope]
        : Array.from(scope.querySelectorAll?.('.bm-home') || []);

      homes.forEach((home) => {
        initializeMobileCarousels(home);
        if (home.dataset.bmCommunityGalleryReady === 'true') return;

        const community = home.querySelector('.bm-community');
        const track = home.querySelector('[data-community-track]');
        const previous = home.querySelector('.bm-gallery-button--prev');
        const next = home.querySelector('.bm-gallery-button--next');
        const slides = Array.from(home.querySelectorAll('[data-community-slide]'));
        const reviews = Array.from(home.querySelectorAll('[data-community-review]'));
        const slideCount = Number(track?.dataset.slideCount || 0);
        if (!community || !track || !previous || !next || slideCount < 1 || slides.length < slideCount) return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const autoplayDelay = Number(community.dataset.communityAutoplay || 3000);
        let position = 0;
        let autoplayTimer;
        let resetTimer;
        let pointerInside = false;
        let focusInside = false;

        const stepSize = () => {
          if (slides.length < 2) return track.clientWidth;
          return slides[1].offsetLeft - slides[0].offsetLeft;
        };

        const setActive = (index) => {
          const activeIndex = ((index % slideCount) + slideCount) % slideCount;

          slides.forEach((slide) => {
            const active = Number(slide.dataset.reviewIndex) === activeIndex;
            slide.classList.toggle('is-active', active);
            slide.toggleAttribute('aria-current', active);
          });

          reviews.forEach((review) => {
            const active = Number(review.dataset.communityReview) === activeIndex;
            review.hidden = !active;
            review.classList.toggle('is-active', active);
            review.setAttribute('aria-hidden', String(!active));
          });
        };

        const scrollToPosition = (target, behavior = 'smooth') => {
          position = target;
          setActive(position);
          track.scrollTo({
            left: stepSize() * position,
            behavior: reducedMotion.matches ? 'auto' : behavior
          });

          if (position === slideCount) {
            window.clearTimeout(resetTimer);
            resetTimer = window.setTimeout(() => {
              position = 0;
              track.scrollTo({ left: 0, behavior: 'auto' });
            }, reducedMotion.matches ? 0 : 520);
          }
        };

        const move = (direction) => {
          window.clearTimeout(resetTimer);

          if (direction > 0) {
            if (position >= slideCount) position = 0;
            scrollToPosition(position + 1);
            return;
          }

          if (position <= 0) {
            position = slideCount;
            track.scrollTo({ left: stepSize() * position, behavior: 'auto' });
          }

          window.requestAnimationFrame(() => scrollToPosition(position - 1));
        };

        const stopAutoplay = () => {
          window.clearInterval(autoplayTimer);
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (reducedMotion.matches || slideCount < 2 || pointerInside || focusInside || document.hidden) return;
          autoplayTimer = window.setInterval(() => move(1), autoplayDelay);
        };

        const restartAutoplay = () => {
          stopAutoplay();
          startAutoplay();
        };

        const handlePrevious = () => {
          move(-1);
          restartAutoplay();
        };

        const handleNext = () => {
          move(1);
          restartAutoplay();
        };

        const handleKeydown = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
          restartAutoplay();
        };

        const handleSlideClick = (event) => {
          const slide = event.currentTarget;
          const index = Number(slide.dataset.reviewIndex || 0);
          scrollToPosition(index);
          restartAutoplay();
        };

        const handlePointerEnter = () => {
          pointerInside = true;
          stopAutoplay();
        };

        const handlePointerLeave = () => {
          pointerInside = false;
          startAutoplay();
        };

        const handleFocusIn = () => {
          focusInside = true;
          stopAutoplay();
        };

        const handleFocusOut = (event) => {
          if (community.contains(event.relatedTarget)) return;
          focusInside = false;
          startAutoplay();
        };

        const handleVisibility = () => {
          if (document.hidden) stopAutoplay();
          else startAutoplay();
        };

        previous.addEventListener('click', handlePrevious);
        next.addEventListener('click', handleNext);
        track.addEventListener('keydown', handleKeydown);
        community.addEventListener('mouseenter', handlePointerEnter);
        community.addEventListener('mouseleave', handlePointerLeave);
        community.addEventListener('focusin', handleFocusIn);
        community.addEventListener('focusout', handleFocusOut);
        document.addEventListener('visibilitychange', handleVisibility);
        slides.forEach((slide) => slide.addEventListener('click', handleSlideClick));

        const resizeObserver = new ResizeObserver(() => {
          track.scrollTo({ left: stepSize() * position, behavior: 'auto' });
        });
        resizeObserver.observe(track);

        setActive(0);
        startAutoplay();

        home.bmCommunityCleanup = () => {
          stopAutoplay();
          window.clearTimeout(resetTimer);
          resizeObserver.disconnect();
          previous.removeEventListener('click', handlePrevious);
          next.removeEventListener('click', handleNext);
          track.removeEventListener('keydown', handleKeydown);
          community.removeEventListener('mouseenter', handlePointerEnter);
          community.removeEventListener('mouseleave', handlePointerLeave);
          community.removeEventListener('focusin', handleFocusIn);
          community.removeEventListener('focusout', handleFocusOut);
          document.removeEventListener('visibilitychange', handleVisibility);
          slides.forEach((slide) => slide.removeEventListener('click', handleSlideClick));
        };

        home.dataset.bmCommunityGalleryReady = 'true';
      });
    };

    initialize();

    if (!window.bmHomeSectionLoadListenerAttached) {
      document.addEventListener('shopify:section:load', (event) => initialize(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        event.target.querySelectorAll?.('.bm-home').forEach((home) => {
          home.bmCommunityCleanup?.();
          home.bmMobileCarouselsCleanup?.();
        });
      });
      window.bmHomeSectionLoadListenerAttached = true;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buddhamani-product-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.bmInitialized === 'true') return;
      section.dataset.bmInitialized = 'true';

      const slides = Array.from(section.querySelectorAll('[data-media-id]'));
      const thumbs = Array.from(section.querySelectorAll('[data-bm-thumb]'));
      const variantInput = section.querySelector('[data-bm-variant-id]');
      const optionGroups = Array.from(section.querySelectorAll('[data-option-position]'));
      const price = section.querySelector('[data-bm-price]');
      const compare = section.querySelector('[data-bm-compare]');
      const inventory = section.querySelector('[data-bm-inventory]');
      const addButton = section.querySelector('[data-bm-add]');
      const addText = section.querySelector('[data-bm-add-text]');
      const quantity = section.querySelector('[name="quantity"]');
      const productForm = section.querySelector('[data-bm-product-form]');
      const dynamicCheckout = section.querySelector('[data-bm-dynamic-checkout]');
      const zoomCurrent = section.querySelector('[data-bm-zoom-current]');
      const variantsNode = section.querySelector('[data-bm-variants]');
      let variants = [];
      let activeIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));

      try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (error) { variants = []; }
      if (variantInput) variantInput.disabled = false;

      const selectMedia = (mediaId) => {
        const nextIndex = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
        if (nextIndex < 0) return;
        slides.forEach((slide, index) => {
          const isActive = index === nextIndex;
          slide.hidden = !isActive;
          if (!isActive) {
            slide.querySelectorAll('video').forEach((video) => video.pause());
            slide.querySelectorAll('model-viewer').forEach((model) => model.pause?.());
            slide.querySelectorAll('iframe').forEach((frame) => {
              frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*');
              frame.contentWindow?.postMessage({ method: 'pause' }, '*');
            });
          }
        });
        thumbs.forEach((thumb) => thumb.setAttribute('aria-current', String(String(thumb.dataset.bmThumb) === String(mediaId))));
        thumbs[nextIndex]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        activeIndex = nextIndex;
        if (zoomCurrent) zoomCurrent.hidden = !slides[nextIndex]?.querySelector('[data-bm-zoom]');
      };

      thumbs.forEach((thumb) => thumb.addEventListener('click', () => selectMedia(thumb.dataset.bmThumb)));
      section.querySelector('[data-bm-gallery-prev]')?.addEventListener('click', () => selectMedia(slides[(activeIndex - 1 + slides.length) % slides.length]?.dataset.mediaId));
      section.querySelector('[data-bm-gallery-next]')?.addEventListener('click', () => selectMedia(slides[(activeIndex + 1) % slides.length]?.dataset.mediaId));

      const dialog = section.querySelector('[data-bm-zoom-dialog]');
      const dialogImage = section.querySelector('[data-bm-zoom-image]');
      const openZoom = (button) => {
        if (!button || !dialog || !dialogImage) return;
        dialogImage.src = button.dataset.zoomSrc;
        dialog.showModal();
      };
      section.querySelectorAll('[data-bm-zoom]').forEach((button) => button.addEventListener('click', () => openZoom(button)));
      section.querySelector('[data-bm-zoom-current]')?.addEventListener('click', () => openZoom(slides[activeIndex]?.querySelector('[data-bm-zoom]')));
      section.querySelector('[data-bm-zoom-close]')?.addEventListener('click', () => dialog?.close());
      dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

      const applyVariant = (variant) => {
        if (!variant) {
          if (variantInput) {
            variantInput.value = '';
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (addButton) addButton.disabled = true;
          if (addText) addText.textContent = 'Unavailable';
          if (inventory) { inventory.textContent = 'Unavailable'; inventory.classList.add('is-sold-out'); }
          if (compare) compare.hidden = true;
          if (dynamicCheckout) dynamicCheckout.hidden = true;
          const url = new URL(window.location.href);
          url.searchParams.delete('variant');
          window.history.replaceState({}, '', url);
          return;
        }
        if (variantInput) {
          variantInput.value = variant.id;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (price) price.textContent = variant.price;
        if (compare) {
          compare.hidden = !variant.compare_at_price;
          compare.textContent = variant.compare_at_price || '';
        }
        if (inventory) {
          const managedStock = variant.inventory_management && variant.inventory_policy === 'deny';
          inventory.textContent = variant.available ? (managedStock && variant.inventory_quantity > 0 ? `${variant.inventory_quantity} in stock` : 'In stock') : 'Sold out';
          inventory.classList.toggle('is-sold-out', !variant.available);
        }
        if (addButton) addButton.disabled = !variant.available;
        if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (dynamicCheckout) dynamicCheckout.hidden = !variant.available;
        if (quantity) {
          const min = Number(variant.quantity_min) || 1;
          const step = Number(variant.quantity_increment) || 1;
          const max = variant.quantity_max ? Number(variant.quantity_max) : Infinity;
          quantity.min = min;
          quantity.step = step;
          if (Number.isFinite(max)) quantity.max = max;
          else quantity.removeAttribute('max');
          let normalized = Number(quantity.value);
          if (!Number.isFinite(normalized)) normalized = min;
          normalized = min + Math.round((normalized - min) / step) * step;
          normalized = Math.max(min, normalized);
          if (Number.isFinite(max)) normalized = Math.min(min + Math.floor((max - min) / step) * step, normalized);
          quantity.value = normalized;
        }
        if (variant.featured_media_id) selectMedia(variant.featured_media_id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        section.dispatchEvent(new CustomEvent('buddhamani:variant-change', { detail: { variant }, bubbles: true }));
      };

      optionGroups.forEach((group) => group.addEventListener('change', () => {
        const selectedOptions = optionGroups.map((item) => item.querySelector('input:checked')?.value);
        const variant = variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]));
        applyVariant(variant);
      }));

      productForm?.addEventListener('submit', (event) => {
        if (!variantInput?.value || addButton?.disabled) event.preventDefault();
      });

      section.querySelector('[data-bm-quantity-minus]')?.addEventListener('click', () => {
        if (!quantity) return;
        const step = Number(quantity.step) || 1;
        const min = Number(quantity.min) || 1;
        quantity.value = Math.max(min, Number(quantity.value || min) - step);
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
      section.querySelector('[data-bm-quantity-plus]')?.addEventListener('click', () => {
        if (!quantity) return;
        const step = Number(quantity.step) || 1;
        const max = quantity.max ? Number(quantity.max) : Infinity;
        quantity.value = Math.min(max, Number(quantity.value || quantity.min || 1) + step);
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    const initAll = (root = document) => root.querySelectorAll('.bm-pm').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
    else initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
